import type { JSX } from 'react';
import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { useUpdateRefereeInfo } from '../hooks/useUpdateRefereeInfo';

interface RefereeDenyFormProps {
  shareId: string;
}

export function RefereeDenyForm({ shareId }: RefereeDenyFormProps): JSX.Element {
  const [comment, setComment] = useState('');
  const { mutate, isPending } = useUpdateRefereeInfo(shareId);

  const handleSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    if (!comment.trim()) return;
    mutate(
      { confirmed: false, refereeComment: comment },
      {
        onSuccess: () => toast.success('Response submitted successfully'),
        onError: () => toast.error('Failed to submit response'),
      }
    );
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="deny-comment">Please explain your choice</Label>
        <Textarea
          id="deny-comment"
          placeholder="Enter your reason"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          disabled={isPending}
        />
      </div>
      <Button type="submit" disabled={isPending || !comment.trim()}>
        {isPending ? 'Submitting...' : 'Submit'}
      </Button>
    </form>
  );
}
